<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student.show,
                    },
                    {
                        name: $tc('messages.comments', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.comment')" for="comment" />
                            <FormTextarea
                                required
                                id="comment"
                                v-model="form.comment"
                                name="comment"
                                type="text"
                                rows="10"
                                class="w-full mt-1"
                            />
                            <FormError :value="form.errors.comment" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormTextarea,
        FormLabel,
        FormError,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'student_file_comment', 'student'],
    data() {
        return {
            form: this.$inertia.form({
                comment: this.student_file_comment.comment,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
